import { axiosConfig } from '../api/axios-config.js'

// MQTT 路由
export const mqttRoute = {
  // 取得清單
  get: (params, token) => axiosConfig.get('/api/mqtt-routes', { ...token, params }),

  // 取得單筆
  getOne: (id, token) => axiosConfig.get(`/api/mqtt-routes/${id}`, token),

  // 創建
  create: (data, token) => axiosConfig.post('/api/mqtt-routes', data, token),

  // 更新
  update: (id, data, token) => axiosConfig.put(`/api/mqtt-routes/${id}`, data, token),

  // 刪除
  delete: (id, token) => axiosConfig.delete(`/api/mqtt-routes/${id}`, token),

  // 刷新路由表
  refresh: (token) => axiosConfig.post('/api/mqtt-routes/refresh', {}, token),

  // 取得機構列表
  getAgencies: (token) => axiosConfig.get('/api/mqtt-routes/agencies', token),

  // 取得管理者列表
  getManagers: (token) => axiosConfig.get('/api/mqtt-routes/managers', token),

  // 預覽影響範圍
  preview: (data, token) => axiosConfig.post('/api/mqtt-routes/preview', data, token)
}